export const DISCARD_CHANGES_CONFIRMATION = 'Esta seguro que quiere continuar? Los cambios editados no seran guardados';
export const UNNASSIGN_CLIENT_CONFIRMATION = 'Esta seguro que desea remover este cliente de la ruta del vendedor?'
